// STYLE
export const DEFAULT_GRID_HEADER_HEIGHT = 40
export const DEFAULT_GRID_ROW_HEIGHT = 34
export const DEFAULT_GRID_COL_DEF = {
  suppressMovable: true,
  resizable: false,
  sortable: true,
  showDisabledCheckboxes: true
}

export const BOOKING_FORM_CONST = {
  HYDRATE_CUSTOMER_FORM_TYPE: {
    SWIPE_ID_CARD: 'swipe_id_card'
  }
}

export const BOOKING_STATUS = {
  BOOKED: 1,
  CI: 2,
  CO: 3,
  CANCEL: 4
}
